module.exports = __webpack_public_path__ + "img/Cutaways_house_3.b4c43176.jpg";